import { render } from "./LogRow.vue?vue&type=template&id=4c6e39bc"
import script from "./LogRow.vue?vue&type=script&lang=js"
export * from "./LogRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__